import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { getCurrency } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';



export default function CurrencyModal(props) {
  const { i18n, t } = useTranslation();
 


  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchApiQuery, setSearchApiQuery] = useState([]);
  const [searchQuery, setSearchQuery] = useState();
  const [currencyData, setCurrencyData] = useState([]);



  useEffect(() => {
    if (props?.currencyList) {
      setSearchApiQuery(props?.currencyList);
      setCurrencyData(props?.currencyList)
    }
  }, [props?.currencyList])




  const handleCurrency = (items) => {
    props.onHide({ selectedCurrency: items })
    props.callGetPrice({ selectedCurrency: items, selectedCrypto: props.selectedCrypto });

  }
  const onClose = () => {
    props.onHide({ selectedCurrency: props?.selectedCurrency })
  }


  const handleChange = (e) => {
    if (e.target.value == "") {
      setCurrencyData(searchApiQuery);
    } else {
      const filterResult = searchApiQuery.filter(
        (item) => 
        item?.name?.toLowerCase()?.includes(e.target.value.toLowerCase()) ||
        item?.symbol?.toLowerCase()?.includes(e.target.value.toLowerCase())

      )
      setCurrencyData(filterResult);
    }
    setSearchQuery(e.target.value)
  }

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="trasaxction-mod selectoken_mod"
    >
      <Button className="close-btn" onClick={onClose}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M6.75806 17.2431L12.0011 12.0001M17.2441 6.75708L12.0001 12.0001M12.0001 12.0001L6.75806 6.75708M12.0011 12.0001L17.2441 17.2431"
            stroke="#000"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </Button>
      <Modal.Body>
        <div className="select_token_modal">
          {/* <h6 className="green-col">Select a token</h6> */}

          <Form className="token_search pt-4">
            <FormGroup className="position-relative">
              <Input
                type="search  "
                name="email"
                id="exampleEmail"
                value={searchQuery}
                placeholder={t('type_currency')}
                onChange={handleChange}

              />
              <div className="search_icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                >
                  <path
                    d="M14.7536 13.5706L11.9212 10.7465C12.835 9.58229 13.3309 8.14459 13.329 6.66452C13.329 5.3464 12.9382 4.05789 12.2059 2.96191C11.4736 1.86594 10.4327 1.01173 9.21492 0.507309C7.99714 0.00288761 6.65713 -0.129092 5.36434 0.12806C4.07155 0.385212 2.88404 1.01995 1.952 1.952C1.01995 2.88404 0.385212 4.07155 0.12806 5.36434C-0.129092 6.65713 0.00288761 7.99714 0.507309 9.21492C1.01173 10.4327 1.86594 11.4736 2.96191 12.2059C4.05789 12.9382 5.3464 13.329 6.66452 13.329C8.14459 13.3309 9.58229 12.835 10.7465 11.9212L13.5706 14.7536C13.6481 14.8317 13.7402 14.8936 13.8417 14.9359C13.9432 14.9782 14.0521 15 14.1621 15C14.2721 15 14.381 14.9782 14.4825 14.9359C14.584 14.8936 14.6761 14.8317 14.7536 14.7536C14.8317 14.6761 14.8936 14.584 14.9359 14.4825C14.9782 14.381 15 14.2721 15 14.1621C15 14.0521 14.9782 13.9432 14.9359 13.8417C14.8936 13.7402 14.8317 13.6481 14.7536 13.5706ZM1.66613 6.66452C1.66613 5.67593 1.95928 4.70955 2.50851 3.88757C3.05774 3.06558 3.83838 2.42493 4.75172 2.04661C5.66506 1.6683 6.67007 1.56931 7.63966 1.76218C8.60925 1.95504 9.49988 2.43109 10.1989 3.13013C10.898 3.82916 11.374 4.71979 11.5669 5.68938C11.7597 6.65898 11.6607 7.66399 11.2824 8.57732C10.9041 9.49066 10.2635 10.2713 9.44148 10.8205C8.6195 11.3698 7.65311 11.6629 6.66452 11.6629C5.33887 11.6629 4.06751 11.1363 3.13013 10.1989C2.19275 9.26154 1.66613 7.99018 1.66613 6.66452Z"
                    fill="#111111"
                  />
                </svg>
              </div>
            </FormGroup>

            <div className="select_token_here">
              <ul>
                {currencyData.length > 0 && currencyData.map((items, index) => {
                  return (
                    <li key={index} onClick={() => handleCurrency(items)}>
                      <div className="token_search_list">
                        <div className="token-icon">
                          <div className="token_icon">
                            <img
                              src={items.icon}
                              alt=""
                              className="img-fluid"
                            />
                          </div>
                          <p>
                            <strong>{items.name}</strong>{" "}
                            {items.symbol}
                          </p>
                        </div>

                        {/* <p className="value_txt">
                              <span className="gren_txt">0</span>.{items.token_value}
                             </p> */}
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
}
